// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1czEd","author":"Table_author__Rjx-6","authorImage":"Table_authorImage__3kb4b","unreadRow":"Table_unreadRow__1WWTz"};